<template>
  <div class="menu-tab white has-nav" id="content">
    <div class="menu-tab-header">
      <div class="nav-items">
        <ul class="menu-items">
          <MenuItem target="chapter" :active="menuTab === 'chapter'" icon-name="icon-content" @click="clickMenuItem" title="Kapittler"/>
          <MenuItem target="page" :active="menuTab === 'page'" icon-name="icon-page-right" @click="clickMenuItem" title="Sider"/>
          <MenuItem target="audio" :active="menuTab === 'audio'" icon-name="icon-sound" @click="clickMenuItem" title="Lyd"/>
          <MenuItem target="hyperlink" :active="menuTab === 'hyperlink'" icon-name="icon-link" @click="clickMenuItem" title="Lenker"/>
        </ul>
      </div>
    </div>
    <div class="menu-tab-content">
      <div class="page-navigation">
        Gå til side <input class="pagenumber" type="text" v-model="pageNumber" /> av {{ $store.getters.book.pages.length }}
      </div>
      <div class="content">
        <keep-alive>
          <ChapterList v-if="menuTab === 'chapter'" />
          <PageList v-else-if="menuTab === 'page'" />
          <AudioList v-else-if="menuTab === 'audio'" />
          <HyperlinkList v-else-if="menuTab === 'hyperlink'" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ChapterList from '@/views/chapter/ChapterList'
import PageList from '@/views/page/PageList'
import AudioList from '@/views/misc/AudioList'
import HyperlinkList from '@/views/misc/HyperlinkList'
import MenuItem from './MenuItem'
import _ from 'lodash'

export default {
  data () {
    return {
      menuTab: 'chapter',
      pageNumber: this.$route.params.pageNumber
    }
  },
  methods: {
    clickMenuItem (target) {
      this.menuTab = target
    },
    debouncePageNumber (newVal) {
    }
  },
  components: {
    ChapterList,
    MenuItem,
    PageList,
    AudioList,
    HyperlinkList
  },
  watch: {
    pageNumber: _.debounce(function (newVal, oldVal) {
      if (newVal !== oldVal && (newVal > 0 && newVal <= this.$store.getters.book.pages.length)) {
        this.pageNumber = newVal
        this.$router.push({ params: { pageNumber: newVal } })
      }
    }, 400),
    '$route.params.pageNumber' (newVal) {
      this.pageNumber = newVal
    }
  }
}
</script>

<style>
  .page-navigation {
    font-size: 0.9em;
    margin-top: -10px;
    position: fixed;
    width: 235px;
    padding: 10px 5px;
    background-color: #FFF;
  }

  .content {
    margin-top: 30px;
  }

  .pagenumber {
    text-align: center;
    border-style: none;
    border-bottom: 1px solid #999;
    font-size: 1em;
    display: inline-block;
    width: 40px;
  }
</style>
